import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import ui from '@alpinejs/ui';
import Flickity from 'flickity';

//Local script for nav
import MainNav from  './mainNav';
import SecondaryNav from './secondaryNav';
import './about';
import './pastRecipients';
import initAccordion from './accordion';
import initFooterScrollTop from './footerScrollTop';
import initFormieInputRestrictions from './formieInputRestrictions';
import initNav from './nav';

document.addEventListener('alpine:init', () => {
    Alpine.plugin(focus);
    Alpine.plugin(ui);

    Alpine.data('MainNav', MainNav);
    Alpine.data('SecondaryNav', SecondaryNav);

    Alpine.directive('flickity',(el, { value, modifiers, expression }, { Alpine, evaluate, cleanup }) => {
        const flickity = new Flickity(el,evaluate(expression));
    });

    Alpine.magic('flickity', () => {return Flickity });

    Alpine.directive('breakpoint', (el, { value, modifiers, expression }, { Alpine, evaluateLater, effect, cleanup }) => {
        let mql = window.matchMedia(`(${value}-width: ${modifiers[0]}px)`);

        // console.log(`@breakpoint: (${value}-width: ${modifiers[0]}px)`)
        // console.log(mql)

        // for initial value
        el.dispatchEvent(new CustomEvent('breakpoint', {
            detail: { matches: mql.matches },
            bubbles: true,
        }));

        mql.addEventListener('change', e => {
            // console.log(e)
            el.dispatchEvent(new CustomEvent('breakpoint', {
                detail: { matches: e.matches },
                bubbles: false,
            }));
        });

        cleanup(() => {
            mql.removeEventListener('change');
        });

    });

    Alpine.directive('scrolltothis', (el, { value, modifiers, expression }, { Alpine, evaluateLater, effect, cleanup}) => {
        el.addEventListener('click', event => {
            event.preventDefault();
            document.querySelector(`.this-${el.dataset.this}`).scrollIntoView({behavior: "smooth"});
        });

        cleanup(() => {
            el.removeEventListener('click');
        });
    });

});

window.Alpine = Alpine;

Alpine.start();

initNav();
initFooterScrollTop();
initFormieInputRestrictions();
initAccordion();

;(function() {
    const ratingFields   = document.querySelector('.rating-fields');
    const conflictNotice = document.querySelector('.conflict-notice');

    const conflictValueChanged = function(value) {
        if ('Yes' === value) {
            ratingFields.classList.add('hidden');
            conflictNotice.classList.add('conflicted');
        } else {
            ratingFields.classList.remove('hidden');
            conflictNotice.classList.remove('conflicted');
        }
    };

    const updateConflictValue = function(elementId, key, rating) {
        if ( 'undefined' === typeof window.starRatings ) {
            return;
        }

        starRatings.rate(elementId, key, rating, true);
    };

    const conflictRadios = document.querySelectorAll('.app-conflict');
    const elementId = document.querySelector('input[name=elementId]')?.value;

    const onConflictValueChange = function(el) {
        if ('undefined' === typeof elementId) {
            return;
        }

        const { name, value } = el.target;

        const rating = 'Yes' === value ? 1 : 0;

        updateConflictValue(elementId, name, rating);

        conflictValueChanged(value);
    }

    conflictRadios.forEach((radio) => {
        radio.addEventListener('change', onConflictValueChange);
    });

    // Handle initial load.
    document.addEventListener('DOMContentLoaded', () => {
        // Find all the "Yes" radios. If checked, hide the rating fields.
        conflictRadios.forEach((radio) => {
            if ('Yes' !== radio.value) {
                return;
            }

            if (radio.checked) {
                conflictValueChanged(radio.value)
            }
        });
    });
})();

;(function() {
    const hiddenValues = [4, 5, 6, 7, 8, 9, 10, 11];

    const applyHiddenClasses = () => {
        hiddenValues.forEach((value) => {
            const selectors = [
                `.sr-element-74-pre-app.sr-value-${value}`,
                `.sr-element-74-pre-app .sr-value-${value}`,
            ];

            selectors.forEach((selector) => {
                document.querySelectorAll(selector).forEach((element) => {
                    element.classList.add('sr-value-hidden');
                });
            });
        });
    };

    document.addEventListener('DOMContentLoaded', applyHiddenClasses);
})();

;(function() {
    const applyBackgroundImages = () => {
        document.querySelectorAll('[data-bg-image]').forEach((element) => {
            const url = element.dataset.bgImage;

            if (!url) {
                return;
            }

            element.style.setProperty('--bgImage', `url('${url}')`);
        });
    };

    document.addEventListener('DOMContentLoaded', applyBackgroundImages);
})();
